<button type="button" class="pa-cmdk-pill" [class.pa-cmdk-pill--icon]="compact" (click)="open()"
        aria-label="Search" aria-haspopup="dialog" [attr.aria-expanded]="isOpen"
        aria-keyshortcuts="Meta+K Control+K">
  <svg class="pa-cmdk-pill__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" aria-hidden="true">
    <circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/>
  </svg>
  <span>Search</span>
  <kbd class="pa-cmdk-pill__kbd">{{ shortcutHint }}</kbd>
</button>

<ng-template #panelTpl>
  <div class="pa-cmdk__panel" tabindex="-1" (keydown)="onPanelKeydown($event)">
    <div class="pa-cmdk__inp">
      <svg class="pa-cmdk__inp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/>
      </svg>
      <input type="text" autocomplete="off" spellcheck="false"
             placeholder="Search customers, transactions, disputes… or jump to a page"
             aria-label="Search" aria-controls="pa-cmdk-list"
             [attr.aria-activedescendant]="results.length ? 'pa-cmdk-opt-' + activeIndex : null"
             [value]="query" (input)="onQueryChange($any($event.target).value)">
      <button type="button" class="pa-cmdk__esc" (click)="close()" aria-label="Close search" title="Close (Esc)">
        <kbd>Esc</kbd>
      </button>
    </div>

    <div class="pa-cmdk__list" id="pa-cmdk-list" role="listbox">
      <div class="pa-cmdk__note" *ngIf="blockedAsCardNumber">
        We don't search card numbers. Try a name, email, amount, or the last 4 digits.
      </div>
      <ng-container *ngIf="!blockedAsCardNumber">
        <ng-container *ngFor="let r of results; let i = index">
          <div class="pa-cmdk__grp" *ngIf="startsGroup(i)">{{ r.group }}</div>
          <div class="pa-cmdk__row" [id]="'pa-cmdk-opt-' + i"
               role="option" tabindex="-1" [attr.aria-selected]="i === activeIndex" [class.is-active]="i === activeIndex"
               (mouseenter)="activeIndex = i" (click)="select(r)" (keydown.enter)="select(r)">
            <span class="pa-cmdk__badge" [ngClass]="'pa-cmdk__badge--' + r.group.toLowerCase()"
                  aria-hidden="true">{{ r.group === 'Navigation' ? '→' : r.group.charAt(0) }}</span>
            <payarc-card-mark *ngIf="r.brand" class="pa-cmdk__brand" [brand]="r.brand" [width]="26"></payarc-card-mark>
            <span class="pa-cmdk__lab"><b>{{ r.label }}</b><small *ngIf="r.sublabel">{{ r.sublabel }}</small></span>
            <span class="pa-cmdk__go" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round"><path d="M9 6h9v9"/><path d="m18 6-9 9-4-4"/></svg>
            </span>
          </div>
        </ng-container>
        <div class="pa-cmdk__note pa-cmdk__note--loading" *ngIf="recordsLoading" role="status">Searching…</div>
        <div class="pa-cmdk__note" *ngIf="!results.length && query.trim() && !recordsLoading">No matches for “{{ query.trim() }}”.</div>
        <div class="pa-cmdk__note" *ngIf="!results.length && !query.trim()">No pages available.</div>
      </ng-container>
    </div>

    <div class="pa-cmdk__hint">
      <span><kbd>↑</kbd><kbd>↓</kbd> navigate</span>
      <span><kbd>↵</kbd> open</span>
      <span><kbd>esc</kbd> close</span>
    </div>
  </div>
</ng-template>
